import { render, staticRenderFns } from "./NewTree.vue?vue&type=template&id=3ecc5161&"
import script from "./NewTree.vue?vue&type=script&lang=js&"
export * from "./NewTree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports